import first from 'lodash/first'
import find from 'lodash/find'
import get from 'lodash/get'
import map from 'lodash/map'
import { Block, PrensaEngine, Typography } from '@xprog/prensa'
import React, { useContext } from 'react'
import { convertLocaleDateWithoutTime } from './utils'
import { ArticleContext } from 'providers/Article'
import { PrensaEngineCSSProp } from '@xprog/prensa/types'
import { useIcon } from 'hooks/useIcon'
import IconButton from 'components/Buttons/IconButton.index'
import { ArticleShareSectionContainer } from '../Article/Article.styled'

type EditaisComponentProps = {
  children?: any
  className?: string
  customProps?: {
    className?: string
  }
}

const ImageHtml = PrensaEngine.styled('img', {
  border: '1px solid #e6e6e6',
  ml: '0px',
  mt: '0px',
  height: '200px',
  width: '200px'
})
const containerProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  width: '100%'
}
const containerTopProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  mt: '$4',
  mb: '$8',
  width: '100%',
  '@lg': {
    align: ['row', 'between', 'top']
  }
}
const containerImageProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  mb: '$8',
  height: '200px',
  width: '200px',
  '@lg': {
    mb: '$0'
  }
}
const containerHeaderProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  width: '100%',
  '@lg': {
    width: 'calc(100% - 220px)'
  }
}
const containerIframeProps: PrensaEngineCSSProp = {
  align: ['column', 'left', 'top'],
  mb: '$8',
  width: '100%',
  iframe: {
    height: '100vh',
    maxHeight: '800px',
    width: '100%'
  }
}
const typographyTitleProps: PrensaEngineCSSProp = {
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: '19px',
  p: '$0',
  m: '$0',
  mb: '$2'
}
const typographyHeadlineProps: PrensaEngineCSSProp = {
  fontFamily: '$primary',
  fontSize: '26px',
  fontWeight: 500,
  lineHeight: '30px',
  letterSpacing: '0.2px',
  p: '$0',
  m: '$0',
  mb: '$1'
}
const typographyTextProps: PrensaEngineCSSProp = {
  fontFamily: '$primary',
  fontSize: '16px',
  fontWeight: 400,
  lineHeight: '23px',
  p: '$0',
  m: '$0',
  mb: '$2'
}

const shareSection = {
  content: [
    {
      id: 'facebookShare',
      alt: 'Compartilhar no Facebook',
      icon: 'IcBotaoFacebookPreto',
      href: 'https://www.facebook.com/sharer/sharer.php?u='
    },
    {
      id: 'twitterShare',
      alt: 'Compartilhar no Twitter',
      icon: 'IcBotaoTwitterPreto',
      href: 'https://twitter.com/intent/tweet?text='
    },
    {
      id: 'whatsappShare',
      alt: 'Compartilhar no WhatsApp',
      icon: 'IcBotaoWhatsAppPreto',
      href: 'https://api.whatsapp.com/send?text='
    }
  ]
}

const EditaisComponent: React.FC<EditaisComponentProps> = (props) => {
  const shareSectionIcons: any = useIcon(
    shareSection.content.map((i: any) => i.icon)
  )
  const shareSectionData: any = shareSectionIcons.map((i: any) => ({
    ...i,
    config: shareSection.content.find((s: any) => s.icon === i.name)
  }))
  const { articles } = useContext(ArticleContext)
  const contentData: any = get(articles, '[0]', {})
  if (!contentData?.id) return <></>
  const articleContentData = get(contentData, 'contentData', [])
  const articleFileIt = 'com.atex.plugins.file.FileContentDataBean'
  const articleImageIt = 'com.atex.standard.image.ImageContentDataBean'
  const articlePdfObject = find(articleContentData, { type: articleFileIt })
  const articleImgObject = find(articleContentData, { type: articleImageIt })
  const articleImgFilePath = get(articleImgObject, 'url', false)
  const articlePdfFilePath = get(articlePdfObject, 'filePath', false)
  const articlePdfVersion = get(articlePdfObject, 'version', false)
  const articleFinalUrl =
    articlePdfFilePath && articlePdfVersion
      ? `/filedelivery/contentid/${articlePdfVersion}/${articlePdfFilePath}`
      : false
  const articleCompany = get(contentData, 'categorization.company', [])
  const articleSector = get(contentData, 'categorization.sector', [])
  const articleType = get(contentData, 'categorization.type', [])
  const publishingTime = get(contentData, 'publishingTime', false)
  const publishedDate = convertLocaleDateWithoutTime(publishingTime, false)
  console.log(`contentData`, articleCompany)
  return (
    <Block css={containerProps}>
      <Block css={containerTopProps}>
{/*         <Block css={containerImageProps}>
          {articleImgFilePath && (
            <ImageHtml alt={first(articleCompany)} src={articleImgFilePath} />
          )}
        </Block> */}
        <Block css={containerHeaderProps}>
          <Typography css={typographyTitleProps} as='h2'>
            Empresa:
          </Typography>

          <Typography css={typographyHeadlineProps} as='h1'>
            {articleCompany[0]}
          </Typography>

          <Typography css={typographyTextProps} as='p'>
            {publishedDate}
          </Typography>
          <Typography css={typographyTitleProps} as='h2'>
            Setor:
          </Typography>
          {map(articleSector, (item, key) => (
            <Typography css={typographyTextProps} as='h2' key={key}>
              {item}
            </Typography>
          ))}
          <Typography css={typographyTitleProps} as='h2'>
            Tipo:
          </Typography>
          <Typography css={typographyTextProps} as='h2'>
            {articleType[0]}
          </Typography>
        </Block>
      </Block>
      {articleFinalUrl && (
        <Block css={containerIframeProps}>
          <iframe src={articleFinalUrl} />
          <ArticleShareSectionContainer>
            {shareSectionData.map((i: any) => (
              <IconButton
                key={i.name}
                href={`${i.config.href}${location.href}`}
                icon={{ src: i.url }}
                linkProps={{
                  target: '_blank',
                  title: i.config.alt,
                  rel: 'noreferrer'
                }}
                css={{ button: { mr: '$2' } }}
              />
            ))}
          </ArticleShareSectionContainer>
        </Block>
      )}
    </Block>
  )
}

export default EditaisComponent
